/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetRuleLatestMetricDataDto } from '../models/GetRuleLatestMetricDataDto';
import type { GraphDto } from '../models/GraphDto';
import type { GroupDecryptedValuesDto } from '../models/GroupDecryptedValuesDto';
import type { HistogramGraphDto } from '../models/HistogramGraphDto';
import type { MetricDataDto } from '../models/MetricDataDto';
import type { MonitorFailingRowsRequestDto } from '../models/MonitorFailingRowsRequestDto';
import type { MonitoringSearchDto } from '../models/MonitoringSearchDto';
import type { MonitorNotificationDestinationsResponseDto } from '../models/MonitorNotificationDestinationsResponseDto';
import type { MonitorQualifyDto } from '../models/MonitorQualifyDto';
import type { MultiMetricsGraphDto } from '../models/MultiMetricsGraphDto';
import type { NullValueDto } from '../models/NullValueDto';
import type { RuleDetailsDto } from '../models/RuleDetailsDto';
import type { RuleDryRunDto } from '../models/RuleDryRunDto';
import type { RuleDryRunResultDto } from '../models/RuleDryRunResultDto';
import type { RuleDto } from '../models/RuleDto';
import type { RuleGroupRequestDto } from '../models/RuleGroupRequestDto';
import type { RuleInfoDto } from '../models/RuleInfoDto';
import type { RuleMetricDatapointsDto } from '../models/RuleMetricDatapointsDto';
import type { RuleMutingBulkDto } from '../models/RuleMutingBulkDto';
import type { RuleMutingDto } from '../models/RuleMutingDto';
import type { RuleMutingV2Dto } from '../models/RuleMutingV2Dto';
import type { RuleOverviewDto } from '../models/RuleOverviewDto';
import type { RulePatchDto } from '../models/RulePatchDto';
import type { RuleQualifyDto } from '../models/RuleQualifyDto';
import type { RuleRunDebugDto } from '../models/RuleRunDebugDto';
import type { RuleRunDto } from '../models/RuleRunDto';
import type { RuleRunPatchDto } from '../models/RuleRunPatchDto';
import type { SearchCollectionRuleMonitoringRecommendationDto } from '../models/SearchCollectionRuleMonitoringRecommendationDto';
import type { TimeSeriesGraphDto } from '../models/TimeSeriesGraphDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RuleService {

    /**
     * Update a rule run
     * @returns any Rule run successfully updated
     * @throws ApiError
     */
    public static updateRuleRun({
        id,
        runId,
        requestBody,
    }: {
        id: string,
        runId: string,
        requestBody: RuleRunPatchDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/internal/v1/rules/{id}/rule-run/new/{runId}',
            path: {
                'id': id,
                'runId': runId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update a rule run with post
     * @returns any Rule run successfully updated
     * @throws ApiError
     */
    public static updateRuleRunPostMethod({
        id,
        runId,
        requestBody,
    }: {
        id: string,
        runId: string,
        requestBody: RuleRunPatchDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/v1/rules/{id}/rule-run/new/{runId}',
            path: {
                'id': id,
                'runId': runId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Append datapoints to a metric of a rule
     * @returns void
     * @throws ApiError
     */
    public static appendRuleMetricDatapoints({
        ruleId,
        requestBody,
    }: {
        ruleId: string,
        requestBody: RuleMetricDatapointsDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/v1/rules/{ruleId}/metrics/append-datapoints',
            path: {
                'ruleId': ruleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Replace the datapoints of the metric of a rule
     * @returns void
     * @throws ApiError
     */
    public static replaceRuleMetricDatapoints({
        ruleId,
        requestBody,
    }: {
        ruleId: string,
        requestBody: RuleMetricDatapointsDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/internal/v1/rules/{ruleId}/metrics/datapoints',
            path: {
                'ruleId': ruleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get the latest data for a metric of a rule
     * @returns MetricDataDto Metric data successfully fetched
     * @throws ApiError
     */
    public static getRuleLatestMetricData({
        ruleId,
        requestBody,
    }: {
        ruleId: string,
        requestBody: GetRuleLatestMetricDataDto,
    }): CancelablePromise<MetricDataDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/v1/rules/{ruleId}/metrics/get-latest-data',
            path: {
                'ruleId': ruleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get decrypted group dimension values for rule run
     * Returns a simplified mapping of group hashes to readable dimension strings
     * @returns string Successfully retrieved decrypted group dimensions
     * @throws ApiError
     */
    public static getDecryptedGroupDimensions({
        ruleRunId,
    }: {
        ruleRunId: string,
    }): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/v1/rules/{ruleRunId}/decrypted-group-dimensions',
            path: {
                'ruleRunId': ruleRunId,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get all rule monitoring recommendations
     * @returns SearchCollectionRuleMonitoringRecommendationDto Successfully fetch all rule monitoring recommendations
     * @throws ApiError
     */
    public static getAllRuleMonitoringRecommendations({
        validationStatus,
        ruleId,
        itemsPerPage = 50,
        domain,
        tag,
        page,
        sort,
    }: {
        /**
         * Filter on validation status
         */
        validationStatus: 'NO_FEEDBACK' | 'VALIDATED' | 'REJECTED',
        /**
         * Filter on ruleId
         */
        ruleId?: string,
        /**
         * The requested number of elements
         */
        itemsPerPage?: number,
        /**
         * Domain searched
         */
        domain?: string,
        /**
         * Filter on given tag ids
         */
        tag?: Array<string>,
        /**
         * The requested page number. Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The resource fields on which to apply the sort, format : property,ASC|DESC
         */
        sort?: Array<string>,
    }): CancelablePromise<SearchCollectionRuleMonitoringRecommendationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/rule-monitoring-recommendations',
            query: {
                'ruleId': ruleId,
                'itemsPerPage': itemsPerPage,
                'domain': domain,
                'validationStatus': validationStatus,
                'tag': tag,
                'page': page,
                'sort': sort,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get AI monitoring recommendations for a rule
     * @returns SearchCollectionRuleMonitoringRecommendationDto Successfully fetched rule monitoring recommendations
     * @throws ApiError
     */
    public static getRuleMonitoringRecommendations({
        ruleId,
        validationStatus,
    }: {
        ruleId: string,
        validationStatus: 'NO_FEEDBACK' | 'VALIDATED' | 'REJECTED',
    }): CancelablePromise<SearchCollectionRuleMonitoringRecommendationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/rule-monitoring-recommendations/rule/{ruleId}',
            path: {
                'ruleId': ruleId,
            },
            query: {
                'validationStatus': validationStatus,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Accept a rule monitoring recommendation
     * @returns any Successfully applied rule monitoring recommendation
     * @throws ApiError
     */
    public static acceptRuleMonitoringRecommendation({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/rule-monitoring-recommendations/{id}/accept',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Reject a rule monitoring recommendation
     * @returns any Successfully dismissed rule monitoring recommendation
     * @throws ApiError
     */
    public static dismissRuleMonitoringRecommendation({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/rule-monitoring-recommendations/{id}/dismiss',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Create a Sifflet rule
     * @returns RuleDto Successfully create Sifflet Rule
     * @throws ApiError
     */
    public static createSiffletRule({
        requestBody,
    }: {
        requestBody: RuleDto,
    }): CancelablePromise<RuleDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/rules',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                426: `Upgrade Required`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Trigger a dry run of Sifflet Rule
     * @returns RuleDryRunResultDto Sifflet Rule dry run result
     * @throws ApiError
     */
    public static siffletRuleDryRun({
        requestBody,
    }: {
        requestBody: RuleDryRunDto,
    }): CancelablePromise<RuleDryRunResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/rules/_dry-run',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get possible null values for a monitoring field in a dataset
     * @returns NullValueDto Successfully retrieved possible null values
     * @throws ApiError
     */
    public static getPossibleNullValues({
        datasetId,
        monitoringFieldName,
    }: {
        datasetId: string,
        monitoringFieldName: string,
    }): CancelablePromise<Array<NullValueDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/rules/_get-possible-null-values',
            query: {
                'datasetId': datasetId,
                'monitoringFieldName': monitoringFieldName,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                426: `Upgrade Required`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update the muted status of multiple rules
     * @returns void
     * @throws ApiError
     */
    public static muteRulesBulk({
        requestBody,
    }: {
        requestBody: RuleMutingBulkDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/rules/mute',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Delete Sifflet rule by given id
     * @returns void
     * @throws ApiError
     */
    public static deleteSiffletRuleById({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/ui/v1/rules/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a single Sifflet rule
     * @returns RuleDto Successfully fetch rule
     * @throws ApiError
     */
    public static getSiffletRuleById({
        id,
    }: {
        id: string,
    }): CancelablePromise<RuleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/rules/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Patch a rule
     * @returns any Successfully patched rule
     * @throws ApiError
     */
    public static patchRule({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: RulePatchDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/ui/v1/rules/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update a Sifflet rule
     * @returns RuleDto Successfully update Sifflet Rule
     * @throws ApiError
     */
    public static updateSiffletRule({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: RuleDto,
    }): CancelablePromise<RuleDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/ui/v1/rules/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                426: `Upgrade Required`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Download failing results of a Sifflet Rule. The CSV created contains the first 20000 rows sent by the Database
     * @returns string Sifflet Rule download failing results
     * @throws ApiError
     */
    public static siffletRuleDownload({
        id,
        exportFormat = 'CSV',
        filteredColumnNames,
        startDate,
        endDate,
        requestBody,
    }: {
        id: string,
        exportFormat?: 'CSV' | 'CSV_FOR_EXCEL' | 'TSV',
        filteredColumnNames?: Array<string>,
        startDate?: number,
        endDate?: number,
        requestBody?: RuleGroupRequestDto,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/rules/{id}/_download',
            path: {
                'id': id,
            },
            query: {
                'exportFormat': exportFormat,
                'filteredColumnNames': filteredColumnNames,
                'startDate': startDate,
                'endDate': endDate,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update the muted status of a rule
     * @returns void
     * @throws ApiError
     */
    public static muteRule({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: RuleMutingDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/rules/{id}/_mute',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Sifflet Monitor's failing rows
     * @returns RuleRunDebugDto Sifflet Monitor's failing rows
     * @throws ApiError
     */
    public static siffletMonitorFailingRows({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: MonitorFailingRowsRequestDto,
    }): CancelablePromise<RuleRunDebugDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/rules/{id}/failing-rows',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get a single Sifflet rule graph
     * @returns any Successfully fetch rule graph
     * @throws ApiError
     */
    public static getSiffletRuleGraph({
        id,
        runId,
    }: {
        id: string,
        runId: string,
    }): CancelablePromise<Array<(GraphDto | HistogramGraphDto | MultiMetricsGraphDto | TimeSeriesGraphDto)>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/rules/{id}/graph/{runId}',
            path: {
                'id': id,
                'runId': runId,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Qualify all the non-qualified anomalies of one group of a rule
     * @returns any Successfully qualified rule group
     * @throws ApiError
     */
    public static qualifyRuleGroupDatapoints({
        id,
        groupValuesHash,
        requestBody,
    }: {
        id: string,
        groupValuesHash: string,
        requestBody: RuleQualifyDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/rules/{id}/groups/{groupValuesHash}/qualify',
            path: {
                'id': id,
                'groupValuesHash': groupValuesHash,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Qualify all the unresolved anomalies of one group of a rule
     * @returns any Successfully qualified rule group
     * @throws ApiError
     */
    public static qualifyRuleGroupDatapointsNew({
        id,
        groupValuesHash,
        requestBody,
    }: {
        id: string,
        groupValuesHash: string,
        requestBody: MonitorQualifyDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/rules/{id}/groups/{groupValuesHash}/qualify-new',
            path: {
                'id': id,
                'groupValuesHash': groupValuesHash,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Update the muted status of a rule with specific mode
     * @returns void
     * @throws ApiError
     */
    public static muteRuleV2({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: RuleMutingV2Dto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/rules/{id}/mute',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Effective notification destinations for a monitor
     * @returns MonitorNotificationDestinationsResponseDto Successfully resolved monitor notification destinations
     * @throws ApiError
     */
    public static getMonitorNotificationDestinations({
        id,
    }: {
        id: string,
    }): CancelablePromise<MonitorNotificationDestinationsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ui/v1/rules/{id}/notification-destinations',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Qualify all the non-qualified anomalies of a rule across all groups
     * @returns any Successfully qualified rule
     * @throws ApiError
     */
    public static qualifyRuleDatapoints({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: RuleQualifyDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/rules/{id}/qualify',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Qualify all the unresolved anomalies of a monitor across all groups
     * @returns any Successfully qualified rule
     * @throws ApiError
     */
    public static qualifyRuleDatapointsNew({
        id,
        requestBody,
    }: {
        id: string,
        requestBody: MonitorQualifyDto,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ui/v1/rules/{id}/qualify-new',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get all Sifflet rules
     * @returns MonitoringSearchDto Successfully fetch all rule catalog assets
     * @throws ApiError
     */
    public static getAllRule({
        textSearch,
        ruleTemplateName,
        lastRunStatus,
        ruleStatus,
        dataset,
        tag,
        datasource,
        criticality,
        domain,
        page,
        itemsPerPage = 25,
        sort,
    }: {
        /**
         * Global text search
         */
        textSearch?: string,
        /**
         * Filter on given rule template name
         */
        ruleTemplateName?: Array<string>,
        /**
         * Filter on given last run statuses
         * @deprecated
         */
        lastRunStatus?: Array<'PENDING' | 'RUNNING' | 'SUCCESS' | 'REQUIRES_YOUR_ATTENTION' | 'TECHNICAL_ERROR' | 'FAILED'>,
        /**
         * Filter on given rule status
         */
        ruleStatus?: Array<'NOT_EVALUATED' | 'PASSING' | 'NEEDS_ATTENTION' | 'FAILING'>,
        /**
         * Filter on given dataset ids
         */
        dataset?: Array<string>,
        /**
         * Filter on given tag ids
         */
        tag?: Array<string>,
        /**
         * Filter on given datasource ids
         */
        datasource?: Array<string>,
        criticality?: Array<number>,
        /**
         * Domain searched
         */
        domain?: string,
        /**
         * The requested page number. Zero-based page index (0..N)
         */
        page?: number,
        /**
         * The number of elements to be returned inside the page. Pass a value of -1, to bypass pagination and fetch all items
         */
        itemsPerPage?: number,
        /**
         * The resource fields on which to apply the sort, format : property,ASC|DESC
         */
        sort?: Array<string>,
    }): CancelablePromise<MonitoringSearchDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/rules',
            query: {
                'textSearch': textSearch,
                'ruleTemplateName': ruleTemplateName,
                'lastRunStatus': lastRunStatus,
                'ruleStatus': ruleStatus,
                'dataset': dataset,
                'tag': tag,
                'datasource': datasource,
                'criticality': criticality,
                'domain': domain,
                'page': page,
                'itemsPerPage': itemsPerPage,
                'sort': sort,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Trigger a run of the given Sifflet rule id
     * @returns RuleRunDto Successfully trigger Sifflet rule manual run
     * @throws ApiError
     */
    public static siffletRuleManualRun({
        id,
    }: {
        id: string,
    }): CancelablePromise<RuleRunDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/rules/{id}/_run',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Decrypt rule groups
     * @returns GroupDecryptedValuesDto Successfully fetch rule groups decryption
     * @throws ApiError
     */
    public static decryptRuleGroups({
        id,
    }: {
        id: string,
    }): CancelablePromise<GroupDecryptedValuesDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/rules/{id}/decrypt',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Sifflet rule details by rule id
     * @returns RuleDetailsDto Successfully fetch rule details
     * @throws ApiError
     */
    public static getSiffletRuleDetails({
        id,
    }: {
        id: string,
    }): CancelablePromise<RuleDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/rules/{id}/details',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Sifflet rule information by rule id
     * @returns RuleInfoDto Successfully fetch rule info
     * @throws ApiError
     */
    public static getSiffletRuleInfo({
        id,
    }: {
        id: string,
    }): CancelablePromise<RuleInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/rules/{id}/info',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

    /**
     * Get Sifflet rule overview by rule id
     * @returns RuleOverviewDto Successfully fetch rule overview
     * @throws ApiError
     */
    public static getSiffletRuleOverview({
        id,
    }: {
        id: string,
    }): CancelablePromise<RuleOverviewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/rules/{id}/overview',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Resource not found`,
                409: `Conflict`,
                500: `Internal server error`,
            },
        });
    }

}
